export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "demo-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "demo-themeWrapLive" */'./LiveThemeImporter'),
  },
};
